import { MiddlewareRebalanceDataDtoFractionalSharePolicyEnum } from '@orbis-systems/orbis-api-clients/middleware';

export const MODELS_TOAST_MESSAGES = {
    MODEL_DELETED: 'Model deleted successfully',
    MODEL_DELETE_FAILED: 'Failed to delete model. Please try again.',
    MODEL_CREATED: 'Model created successfully',
    MODEL_CREATE_FAILED: 'Failed to create model. Please try again.',
    MODEL_SAVE_DEFAULT_REBALANCE_THRESHOLD_FAILED:
        'Failed to save the Default Rebalancing Threshold. Please try updating it again later.',
    MODEL_UPDATED: 'Model settings updated successfully',
    MODEL_UPDATE_FAILED: 'Failed to update model. Please try again.',
    MODEL_COMPONENTS_UPDATE_FAILED: (symbols: string[]) =>
        `Failed to update model target portfolio for ${symbols.join(', ')}. Please try updating it again later.`,
    MODEL_COMPONENT_UPDATE_FAILED: (symbol: string) =>
        `Failed to update model target portfolio for ${symbol}. Please try updating it again later.`,
    MODEL_UPDATE_DEFAULT_REBALANCE_THRESHOLD_FAILED:
        'Failed to update the Default Rebalancing Threshold. Please try updating it again later.',
    MODEL_ACCOUNTS_UNLINKED: 'Accounts unlinked from model successfully',
    MODEL_UNLINK_ACCOUNTS_FAILED: 'Failed to unlink accounts. Please try again.',
    MODEL_ACCOUNTS_LINKED: 'Accounts added to model successfully',
    MODEL_ACCOUNTS_LINK_FAILED: 'Failed to add accounts to model. Please try again.',
};

export const MODEL_FRACTIONAL_SHARE_POLICY_OPTIONS = [
    { value: MiddlewareRebalanceDataDtoFractionalSharePolicyEnum.Fractional, label: 'Fractional' },
    { value: MiddlewareRebalanceDataDtoFractionalSharePolicyEnum.RoundUp, label: 'Round Up' },
    { value: MiddlewareRebalanceDataDtoFractionalSharePolicyEnum.RoundDown, label: 'Round Down' },
];

export const MODEL_PREFERENCES_DATA_PREFIX = 'ria.web.model';
